import React, { lazy, Suspense } from 'react';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import { create as createFedopsLogger } from '@wix/fedops-logger';
import ReactDOM from 'react-dom';
import '@wix/design-system/styles.global.css';
import { PageWithScriptInstaller } from './components/App/PageWithScriptInstaller';

const fedopsLogger = createFedopsLogger('installer-standalone');

const i18n = initI18n({
  locale: window.__LOCALE__,
  messages: window.__MESSAGES__,
});

const domNode = document.getElementById('root')!;

// the library is used for sleds, to test changes in CI (doesn't work in script version)
const renderByLibrary = window.location.search.includes('renderByLibrary=true');
const PageWithLibraryInstaller = lazy(
  () => import('./components/App/PageWithLibraryInstaller'),
);

ReactDOM.render(
  <Suspense fallback={<></>}>
    <I18nextProvider i18n={i18n}>
      {renderByLibrary ? (
        <Suspense fallback={<></>}>
          <PageWithLibraryInstaller />
        </Suspense>
      ) : (
        <PageWithScriptInstaller />
      )}
    </I18nextProvider>
  </Suspense>,
  domNode,
  () => {
    fedopsLogger.appLoaded();
  },
);
